import { makeStyles } from 'tss-react/mui'


export const useStyles = makeStyles()((theme) => {
    return {
        tableRow: {
            height: '41px'
        },
        tableCell: {
            padding: '1px',
            textAlign: 'center'
        },
        headerRow: {
            height: '26px'
        },
        headerCell: {
            padding: '1px',
            textAlign: 'center',
            fontWeight: 400,
            fontSize: '0.75rem',
            lineHeight: 1.66,
            letterSpacing: '0.03333em'
        }
    }
})